import { isString as ee, uniq as te, omit as R } from "lodash-es";
import { z as t } from "zod";
import { T as l } from "./base-DFJERsUx.js";
import { C as ne } from "./cron-CJR9-b_h.js";
import { UserIdZ as E, UserAddressZ as C } from "./user.js";
import { stripUndefinedOnEncode as z, getNaiveToday as oe } from "./utils.js";
import { utc as K } from "@date-fns/utc";
import { differenceInCalendarDays as ae, endOfDay as ie, addMonths as re } from "date-fns";
const k = t.string().brand("RoomId"), h = t.string().brand("BookingId"), se = t.string().brand("PricingId"), D = t.string().brand("EquipId"), x = t.string().brand("EquipGroupId"), de = t.string().brand("CalendarId"), ce = t.string().brand("EquipCalendarId"), W = t.string().brand("PaymentId"), le = /^[A-Z0-9]+$/, Z = t.string().min(3).regex(le).brand("PromoId").or(t.literal("NONE")).or(t.literal("SOLO")), B = t.enum([
  "NEW",
  "UNAVAILABLE",
  "EXPIRE",
  "PAID",
  "UNPAID"
]), qe = (n) => ["NEW", "UNAVAILABLE"].includes(n), Ue = (n) => ["NEW", "UNAVAILABLE", "EXPIRE"].includes(n), q = t.object({
  room: k,
  start: l,
  end: l
}), ve = q.extend({
  bid: h,
  expire: l.optional()
}), Te = q.extend({
  id: de,
  uid: E,
  bid: h,
  status: B,
  price: t.number(),
  tag: t.enum(["unavailable"]).optional(),
  expire: l.optional()
}), Be = t.object({
  id: ce,
  bid: h,
  eid: D,
  name: t.string(),
  start: l,
  end: l,
  expire: l.optional()
}), G = q.extend({
  price: t.number(),
  tag: t.enum(["unavailable", "affordable"]).optional()
}), $ = t.object({
  id: D,
  name: t.string(),
  price: t.number()
}), X = $.extend({
  tag: t.enum(["unavailable"]).optional()
}), ue = t.enum([
  "sumup",
  /*LEGACY*/
  "paypal"
]), A = t.enum([...ue.options, "cash"]), pe = t.enum(["COMPLETED", "CREATED", "VOIDED"]), F = t.object({
  id: W,
  via: A,
  ref: t.string(),
  status: pe,
  created: l,
  updated: l,
  amount: t.number(),
  uid: E,
  address: C.nullable()
}), Ie = F.extend({
  bid: h,
  data: t.record(t.string(), t.any()).nullable()
}), je = t.object({
  id: k,
  title: t.string(),
  start: t.number(),
  end: t.number(),
  index: t.number(),
  summary: t.string(),
  video_url: t.string(),
  affordable: t.boolean().optional()
}), Pe = t.object({
  id: se,
  promo: Z.default("NONE"),
  title: t.string(),
  start: l,
  end: l,
  cron: ne,
  price: t.record(k, t.number()),
  tag: t.enum(["affordable"]).optional()
}), me = t.array(
  t.object({
    days: t.number().int().positive(),
    discount: t.number().min(0).lt(1)
  })
).superRefine((n, e) => {
  for (let d = 1; d < n.length; d++)
    n[d].days <= n[d - 1].days && e.addIssue({
      code: "custom",
      path: [d, "days"],
      message: "Days must be in ascending order"
    }), n[d].discount <= n[d - 1].discount && e.addIssue({
      code: "custom",
      path: [d, "discount"],
      message: "Discounts must be in ascending order"
    });
}), H = {
  id: Z,
  start: l,
  end: l
}, Oe = t.discriminatedUnion("type", [
  t.object({
    type: t.literal("room"),
    ...H,
    discount: t.number(),
    discountThreshold: t.number()
  }),
  t.object({
    type: t.literal("equip"),
    ...H,
    discountDays: me
  })
]), fe = t.enum(["room", "daily", "hourly"]), Re = $.extend({
  room: k.optional(),
  group: x,
  span: fe,
  img: t.string().startsWith("/").optional(),
  description: t.string().default(""),
  quantity: t.number()
}), xe = t.object({
  title: t.string(),
  name: t.string(),
  index: t.number(),
  id: x
}), O = {
  id: h,
  uid: E,
  amount: t.number(),
  price: t.number(),
  paid: t.number(),
  promo: Z
}, U = t.object({
  ...O,
  status: B,
  sum: t.partialRecord(t.enum([...A.options, "unpaid"]), t.number()),
  payment: F.optional(),
  created: l,
  updated: l,
  expire: l.optional(),
  notes: t.string().optional()
}), I = {
  equipment: X.array().nullable(),
  rooms: t.array(k),
  hours: t.number()
}, Ae = t.object({
  ...U.shape,
  ...I
}), j = {
  equipment: t.array(X),
  start: l,
  end: l,
  address: C.nullable(),
  days: t.number()
}, Ne = t.object({
  ...U.shape,
  ...j
}), Se = t.enum(["room", "equip"]), He = t.discriminatedUnion("type", [
  t.object({
    type: t.literal("room"),
    ...I
  }),
  t.object({
    type: t.literal("equip"),
    ...j
  })
]).and(U), Me = [
  .../* @__PURE__ */ new Set([
    ...Object.keys(U.shape),
    ...Object.keys(I),
    ...Object.keys(j)
  ])
], J = U.pick({
  status: !0,
  notes: !0,
  amount: !0
}), Q = t.object({
  uid: E,
  promo: Z,
  calendar: t.array(G),
  equipment: t.array(D).nullable()
}), Le = Q.extend(
  J.shape
), Y = t.object({
  uid: E,
  promo: Z,
  address: C.nullable(),
  start: l,
  end: l,
  equipment: t.array(D),
  groupId: x.optional()
}), _e = Y.extend(
  J.shape
), Ve = z(
  t.discriminatedUnion("type", [
    Q.extend({
      bid: h,
      type: t.literal("room")
    }),
    Y.extend({
      bid: h,
      type: t.literal("equip")
    })
  ])
), M = t.object({
  notes: t.string().trim().max(500).optional(),
  uid: E.optional(),
  amount: t.number().gte(0),
  status: B,
  promo: Z.optional().default("NONE")
}), ze = z(
  t.discriminatedUnion("type", [
    t.object({
      type: t.literal("room"),
      ...M.shape,
      equipment: t.array(D).nonempty().nullable(),
      calendar: t.array(q).nonempty()
    }),
    t.object({
      type: t.literal("equip"),
      ...M.shape,
      equipment: t.array(D).nonempty(),
      start: l,
      end: l,
      address: C.nullable()
    })
  ])
), L = t.object({
  notes: t.string().trim().max(500),
  uid: E,
  amount: t.number().gte(0),
  status: B,
  promo: Z.optional().default("NONE")
}), Ke = t.tuple([
  h,
  t.discriminatedUnion("type", [
    t.object({
      type: t.literal("room"),
      ...L.shape,
      equipment: t.array(D).nonempty().nullable(),
      calendar: t.array(q).nonempty()
    }),
    t.object({
      type: t.literal("equip"),
      ...L.shape,
      equipment: t.array(D).nonempty(),
      start: l,
      end: l,
      address: C.nullable()
    })
  ])
]), We = t.object({
  id: W,
  created: l,
  name: t.string(),
  uid: E,
  via: A,
  address: C,
  amount: t.number(),
  booking: t.discriminatedUnion("type", [
    t.object({
      type: t.literal("room"),
      ...O,
      ...I,
      calendar: t.array(G)
    }),
    t.object({
      type: t.literal("equip"),
      ...O,
      ...j
    })
  ])
}), Ge = (n) => {
  const e = n.data();
  return e.id = n.id, "type" in e && "promo" in e || (e.type = e.type ?? "room", e.promo = e.solo ? "SOLO" : "NONE", "payment" in e && ("pid" in e.payment && (e.payment.id = e.payment.pid), "expire" in e.payment && (e.expire = e.payment.expire), "status" in e.payment || (e.payment.status = "CREATED"), "created" in e.payment || (e.payment.created = e.updated), "updated" in e.payment || (e.payment.updated = e.updated), "uid" in e.payment || (e.payment.uid = e.uid), "address" in e.payment || (e.payment.address = {
    first_name: "Mock",
    last_name: "Mock",
    phone: "",
    email: "mock@example.com",
    country_code: "DE",
    postal_code: "13347",
    admin_area_1: "",
    admin_area_2: "Berlin",
    address_line_1: "Mock Street 1",
    address_line_2: ""
  })), e.expire || delete e.expire, "equipment" in e && Array.isArray(e.equipment) && (e.equipment = ee(e.equipment[0]) ? e.equipment.map((d) => {
    var c;
    const s = ((c = e.sum) == null ? void 0 : c[d]) ?? 0;
    return s && delete e.sum[d], {
      id: d,
      name: d,
      price: s
    };
  }) : e.equipment.map((d) => ({ name: d.id, ...d })))), e;
}, $e = (n) => {
  const e = n.data();
  return e.id = n.id, e.ref = e.ref ?? "", "payer" in e && ("uid" in e.payer && (e.payer.id = e.payer.uid), "address" in e.payer && (e.address = { ...e.payer, ...e.payer.address })), e;
}, Xe = (n) => {
  var d, s;
  const e = n.data();
  return e.id = n.id, e.bid = (s = (d = n.ref.parent) == null ? void 0 : d.parent) == null ? void 0 : s.id, "name" in e || (e.name = ""), e;
}, Fe = (n) => {
  var d, s;
  const e = n.data();
  return e.id = n.id, e.bid = (s = (d = n.ref.parent) == null ? void 0 : d.parent) == null ? void 0 : s.id, e;
}, Je = (n) => {
  const e = n.data();
  if (e.id = n.id, "booking" in e) return e;
  let d = 0;
  for (const s of e.calendar) d += s.price;
  if (e.equipment) for (const s of e.equipment) d += s.price;
  return e.booking = {
    type: "room",
    id: e.bid,
    price: d,
    paid: e.amount,
    promo: e.solo ? "SOLO" : "NONE",
    rooms: [],
    ...e
  }, "calendar" in e && (e.booking.rooms = te(
    e.calendar.map((s) => s.room)
  )), e.address = { ...e.payer, ...e.payer.address }, e.uid = e.payer.uid, e;
}, Qe = ({ start: n, end: e }, d) => d >= n && d <= e, Ye = ({ expire: n }) => !n || n >= /* @__PURE__ */ new Date(), v = (n, e) => n && (n.length === 1 && e !== n[0] || n.length === 2 && (e < n[0] || e > n[1])), ge = (n, e) => n && (n.length === 1 && e !== n[0] || n.length === 2 && (e < n[0] || e >= n[1])), N = (n, e, d, s) => d >= n && d < e || s > n && s <= e || n >= d && n < s;
function _(n, e, d, s, c) {
  s = new Date(s);
  const i = s.getUTCHours() + s.getUTCMinutes() / 60;
  for (const a of e) {
    if (a.promo !== n || a.tag && c !== a.tag) continue;
    const { cron: o, price: r } = a;
    if (!(!r || // !(room in price) ||
    !r[d] || s < a.start || s >= ie(a.end, { in: K }) || ge(o.hour, i) || v(o.date, s.getUTCDate()) || v(o.month, s.getUTCMonth()) || v(o.day, s.getUTCDay()) && v(o.day, s.getUTCDay() + 7)))
      return r[d];
  }
}
const T = (n, e) => {
  const { room: d, tag: s } = e;
  let { start: c, end: i } = e, a = !1;
  for (let o = 0; o < n.length; ) {
    const r = n[o];
    if (r.room !== d || r.tag !== s) {
      o++;
      continue;
    }
    if (c >= r.start && i <= r.end)
      return !0;
    if (c <= r.start && i >= r.end) {
      n.splice(o, 1), a = !0;
      continue;
    }
    if (c >= r.start && c <= r.end) {
      a = a || c < r.end, c = r.start, n.splice(o, 1);
      continue;
    }
    if (i >= r.start && i <= r.end) {
      a = a || i > r.start, i = r.end, n.splice(o, 1);
      continue;
    }
    o++;
  }
  return n.push({ ...e, start: c, end: i }), a;
}, et = (n, e) => {
  const { room: d, tag: s } = e;
  let { start: c, end: i, price: a } = e;
  for (let o = 0; o < n.length; ) {
    const r = n[o];
    if (r.room !== d || r.tag !== s) {
      o++;
      continue;
    }
    if (c >= r.start && i <= r.end)
      throw new Error("Calendar overlap: inside");
    if (c <= r.start && i >= r.end)
      throw new Error("Calendar overlap: cover");
    if (c >= r.start && c <= r.end) {
      if (c < r.end) throw new Error("Calendar overlap: stretch right");
      c = r.start, a += r.price, n.splice(o, 1);
      continue;
    }
    if (i >= r.start && i <= r.end) {
      if (i > r.start) throw new Error("Calendar overlap: stretch left");
      i = r.end, a += r.price, n.splice(o, 1);
      continue;
    }
    o++;
  }
  n.push({ ...e, start: c, end: i, price: a });
}, tt = (n, e) => {
  const { room: d, start: s, end: c } = e;
  for (let i = 0; i < n.length; ) {
    const a = n[i];
    if (!a.start || !a.end || a.room !== d) {
      i++;
      continue;
    }
    if (s <= a.start && c >= a.end) {
      n.splice(i, 1);
      continue;
    }
    if (s > a.start && c < a.end) {
      const o = { ...a };
      a.end = s, o.start = c, n.splice(i + 1, 0, o);
      return;
    }
    c < a.end && c > a.start ? a.start = c : s > a.start && s < a.end && (a.end = s), i++;
  }
}, nt = (n, e, d) => {
  let s = 0, c = 0;
  for (const o of n) {
    o.price = 0;
    const r = new Date(o.start), { end: p } = o;
    for (; r < p; ) {
      const u = _(
        "NONE",
        d.pricing,
        o.room,
        r,
        o.tag
      );
      if (u === void 0)
        throw new Error(
          `No pricing available: ${o.room}, ${r.toISOString()}`
        );
      if (o.tag !== "unavailable") {
        const g = d.id !== "NONE" ? _(d.id, d.pricing, o.room, r, o.tag) : void 0;
        s += u, c += g || u, o.price += g || u;
      } else
        o.price += u;
      r.setUTCHours(r.getUTCHours() + 1);
    }
  }
  const i = [];
  for (const o of n)
    o.tag !== "unavailable" && T(i, {
      room: null,
      start: new Date(o.start),
      end: new Date(o.end)
    });
  let a = 0;
  for (const o of i)
    a += (o.end.getTime() - o.start.getTime()) / 36e5;
  if (e)
    for (const o of e) {
      if (o.tag === "unavailable") continue;
      const r = o.price * a;
      c += r, s += r;
    }
  return {
    price: s,
    amount: d && s >= d.discountThreshold ? c * (1 - d.discount) : c,
    hours: a,
    allCalendar: i
  };
}, P = (n, e, d, s) => n.find(
  (c) => (!e || c.room === e) && N(c.start, c.end, d, s)
);
function V(n, e, d, s) {
  const { start: c, end: i } = n;
  if (N(e, d, c, i)) {
    const a = [];
    return c < e ? (a.push({ ...n, start: new Date(c), end: new Date(e) }), i > d ? a.push(
      {
        ...n,
        start: new Date(e),
        end: new Date(d),
        tag: s
      },
      { ...n, start: new Date(d), end: new Date(i) }
    ) : a.push({ ...n, start: new Date(e), end: new Date(i), tag: s })) : i > d ? a.push(
      { ...n, start: new Date(c), end: new Date(d), tag: s },
      { ...n, start: new Date(d), end: new Date(i) }
    ) : a.push({ ...n, tag: s }), a;
  }
}
function be({ rooms: n }, e, d) {
  const s = [], c = [...n].reverse();
  for (const i of c)
    if (!i.affordable)
      for (let a = i.start; a < i.end; a++) {
        const o = new Date(e);
        o.setUTCHours(Math.floor(a), a % 1 * 60);
        const r = new Date(o);
        r.setUTCHours(r.getUTCHours() + 1), !P(d, i.id, o, r) && !P(s, null, o, r) && T(s, { room: i.id, start: o, end: r, tag: "affordable" });
      }
  for (const i of c)
    if (i.affordable)
      for (let a = i.start; a < i.end; a++) {
        const o = new Date(e);
        o.setUTCHours(Math.floor(a), a % 1 * 60);
        const r = new Date(o);
        r.setUTCHours(r.getUTCHours() + 1), P(d, i.id, o, r) || T(s, { room: i.id, start: o, end: r, tag: "affordable" });
      }
  return s;
}
const ot = async (n, e, d, s) => {
  for (let i = 0; i < e.length; i++) {
    const a = e[i];
    a.tag && e.splice(i, 1, R(a, "tag"));
  }
  if (s)
    for (let i = 0; i < e.length; i++) {
      const a = e[i];
      if (a.start <= s.from) {
        const o = new Date(a.start);
        o.setUTCHours(
          o.getUTCHours() + Math.ceil((s.from.getTime() - o.getTime()) / 36e5)
        ), o < a.end ? (e.splice(
          i,
          1,
          {
            ...a,
            tag: "unavailable",
            start: new Date(a.start),
            end: new Date(o)
          },
          { ...a, start: o }
        ), i++) : e.splice(i, 1, { ...a, tag: "unavailable" });
      }
      if (a.end > s.to) {
        const o = new Date(a.end);
        o.setUTCHours(
          o.getUTCHours() - Math.ceil((o.getTime() - s.to.getTime()) / 36e5)
        ), a.start < o ? (e.splice(
          i,
          1,
          { ...a, end: o },
          {
            ...a,
            tag: "unavailable",
            start: new Date(o),
            end: new Date(a.end)
          }
        ), i++) : e.splice(i, 1, { ...a, tag: "unavailable" });
      }
    }
  const c = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (i.tag === "unavailable") continue;
    const a = new Date(i.start);
    a.setUTCHours(0, 0, 0, 0);
    const o = a.getTime(), r = c.get(o) || {}, p = r[i.room] || [];
    c.set(o, r), r[i.room] = p, p.push(i);
  }
  for (const [i, a] of c.entries()) {
    const o = new Date(i), r = await d(o);
    for (const { room: p, start: u, end: g } of r) {
      const b = a[p];
      if (b)
        for (let m = 0; m < b.length; m++) {
          const f = b[m];
          if (f.tag === "unavailable") continue;
          const y = V(f, u, g, "unavailable");
          if (y) {
            const w = e.indexOf(f);
            if (w === -1) throw new Error("Calendar race condition");
            e.splice(w, 1, ...y), b.splice(m, 1, ...y), m += y.length - 1;
          }
        }
    }
    if (n != null && n.rooms) {
      const p = be(
        { rooms: n.rooms },
        o,
        r
      );
      for (const { room: u, start: g, end: b } of p) {
        const m = a[u];
        if (m)
          for (let f = 0; f < m.length; f++) {
            const y = m[f];
            if (y.tag) continue;
            const w = V(y, g, b, "affordable");
            if (w) {
              const S = e.indexOf(y);
              if (S === -1) throw new Error("Calendar race condition");
              e.splice(S, 1, ...w), m.splice(f, 1, ...w), f += w.length - 1;
            }
          }
      }
    }
  }
  return e.some((i) => i.tag === "unavailable");
}, at = async (n, e, d) => {
  const s = [];
  for (const o of n)
    o.tag !== "unavailable" && T(s, {
      room: null,
      start: new Date(o.start),
      end: new Date(o.end)
    });
  const c = /* @__PURE__ */ new Map();
  for (const o of s) {
    const r = new Date(o.start);
    r.setUTCHours(0, 0, 0, 0);
    const p = r.getTime(), u = c.get(p) || [];
    c.set(p, u), u.push(o);
  }
  const i = /* @__PURE__ */ new Set();
  for (const [o, r] of c.entries()) {
    const p = await d(new Date(o));
    for (const { start: u, end: g, eid: b } of p)
      for (const m of r)
        N(u, g, m.start, m.end) && i.add(b);
  }
  if (!e)
    return i.size ? i : void 0;
  const a = /* @__PURE__ */ new Set();
  for (let o = 0; o < e.length; o++) {
    const r = e[o];
    i.has(r.id) ? (a.add(r.id), r.tag !== "unavailable" && e.splice(o, 1, { ...r, tag: "unavailable" })) : r.tag === "unavailable" && e.splice(o, 1, R(r, "tag"));
  }
  return a.size ? a : void 0;
}, it = (n) => {
  const e = oe(n.time_zone);
  return { from: e, to: re(e, 2, { in: K }) };
}, rt = (n, e, d, s) => {
  const c = ae(e, n) + 1, i = d.reduce(
    (o, r) => r.tag === "unavailable" ? o : o + r.price * c,
    0
  );
  let a = 0;
  for (const o of (s == null ? void 0 : s.discountDays) ?? [])
    c >= o.days && (a = o.discount);
  return {
    start: n,
    end: e,
    days: c,
    price: i,
    amount: i * (1 - a)
  };
}, st = (n, e, d) => {
  const s = new Set(d.map((i) => i.eid)), c = /* @__PURE__ */ new Set();
  for (let i = 0; i < e.length; i++) {
    const a = e[i];
    if (!s.has(a.id)) {
      a.tag === "unavailable" && e.splice(i, 1, R(a, "tag"));
      continue;
    }
    if (n != null && n.equip) {
      e: for (const { id: o, name: r } of n.equip)
        if (a.id !== o && r === a.name && !s.has(o)) {
          e.splice(i, 1, { id: o, name: r, price: a.price });
          break e;
        }
    }
    e.splice(i, 1, { ...a, tag: "unavailable" }), c.add(a.id);
  }
  return c.size ? c : void 0;
};
export {
  J as BookingAdminLocalZ,
  U as BookingBaseZ,
  ze as BookingCreateZ,
  X as BookingEquipZ,
  h as BookingIdZ,
  Ve as BookingLocalZ,
  G as BookingRoomHoursZ,
  B as BookingStatusZ,
  Se as BookingTypeZ,
  Ke as BookingUpdateZ,
  He as BookingZ,
  de as CalendarIdZ,
  ve as CalendarZ,
  me as DiscountDaysZ,
  _e as EquipBookingAdminLocalZ,
  Y as EquipBookingLocalZ,
  Ne as EquipBookingZ,
  ce as EquipCalendarIdZ,
  Be as EquipCalendarZ,
  x as EquipGroupIdZ,
  xe as EquipGroupZ,
  D as EquipIdZ,
  fe as EquipSpanZ,
  Re as EquipZ,
  $ as EquipmentZ,
  We as InvoiceZ,
  F as PaymentBaseZ,
  W as PaymentIdZ,
  ue as PaymentOnlineViaZ,
  pe as PaymentStatusZ,
  A as PaymentViaZ,
  Ie as PaymentZ,
  se as PricingIdZ,
  Z as PromoIdZ,
  le as PromoRE,
  Oe as PromoZ,
  Le as RoomBookingAdminLocalZ,
  Q as RoomBookingLocalZ,
  Ae as RoomBookingZ,
  q as RoomHoursZ,
  k as RoomIdZ,
  Pe as RoomPricingZ,
  je as RoomZ,
  Te as UserCalendarZ,
  Ge as bookingDocMapper,
  Me as bookingKeys,
  rt as calcEquipBookingPrice,
  nt as calcRoomBookingPrice,
  T as calendarAdd,
  et as calendarAddWithPrice,
  Fe as calendarDocMapper,
  tt as calendarRemove,
  st as checkEquipUnavailable,
  at as checkRoomEquipUnavailable,
  ot as checkRoomHoursUnavailable,
  Xe as equipCalendarDocMapper,
  _ as findRoomHourPrice,
  be as getAffordableDayCalendar,
  it as getAvailableRange,
  Je as invoiceDocMapper,
  qe as isBookingUnreserved,
  Ue as isBookingUnreservedOrExpire,
  Ye as isNotExpired,
  Qe as isPromoActive,
  $e as paymentDocMapper
};
//# sourceMappingURL=booking.js.map
